import { render } from "./Divider.component.vue?vue&type=template&id=2275756e&scoped=true&ts=true"
import script from "./Divider.component.vue?vue&type=script&lang=ts"
export * from "./Divider.component.vue?vue&type=script&lang=ts"

import "./Divider.component.vue?vue&type=style&index=0&id=2275756e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2275756e"]])

export default __exports__